import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Route,
  Navigate,
} from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import { LoginPage } from './pages/LoginPage';
import { MainLayout } from './components/layout/MainLayout';
import { DashboardPage } from './pages/DashboardPage';
import { UsersPage } from './pages/UsersPage';
import { UserDetailPage } from './pages/UserDetailPage';
import { TeamsPage } from './pages/TeamsPage';
import { WorkflowsPage } from './pages/WorkflowsPage';
import { ExecutionsPage } from './pages/ExecutionsPage';
import { AIPage } from './pages/AIPage';
import { SubscriptionsPage } from './pages/SubscriptionsPage';
import { TemplatesPage } from './pages/TemplatesPage';
import { FilesPage } from './pages/FilesPage';
import { APIKeysPage } from './pages/APIKeysPage';
import { WebhooksPage } from './pages/WebhooksPage';
import { RiskPage } from './pages/RiskPage';
import { LogsPage } from './pages/LogsPage';
import { ConfigPage } from './pages/ConfigPage';
import { ActivationCodesPage } from './pages/ActivationCodesPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="users/:id" element={<UserDetailPage />} />
        <Route path="teams" element={<TeamsPage />} />
        <Route path="workflows" element={<WorkflowsPage />} />
        <Route path="executions" element={<ExecutionsPage />} />
        <Route path="ai" element={<AIPage />} />
        <Route path="subscriptions" element={<SubscriptionsPage />} />
        <Route path="templates" element={<TemplatesPage />} />
        <Route path="files" element={<FilesPage />} />
        <Route path="api-keys" element={<APIKeysPage />} />
        <Route path="webhooks" element={<WebhooksPage />} />
        <Route path="risk" element={<RiskPage />} />
        <Route path="logs" element={<LogsPage />} />
        <Route path="config" element={<ConfigPage />} />
        <Route path="activation-codes" element={<ActivationCodesPage />} />
      </Route>
    </>
  )
);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
